module.exports = __webpack_public_path__ + "img/IMG_0174.6bd42221.jpg";